import { useEffect, useState } from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";

// Public topojson with country boundaries — hosted on unpkg for react-simple-maps.
const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

/**
 * Live sessions world map. Renders each session with a pulsing dot at
 * its geo lat/lon. Dots cluster near the same lat/lon slightly randomized
 * so overlapping cities remain distinguishable.
 */
export default function LiveSessionsMap({ dots = [], testid }) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    // Warm-up: mark ready after first paint so the map animates in
    const t = setTimeout(() => setReady(true), 50);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="w-full" data-testid={testid}>
      <div className="border border-[var(--border)]">
        <ComposableMap
          projectionConfig={{ scale: 130 }}
          width={900}
          height={420}
          style={{ width: "100%", height: "auto" }}
        >
          <Geographies geography={GEO_URL}>
            {({ geographies }) =>
              geographies.map((geo) => (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill="#e7e5e4"
                  stroke="#d6d3d1"
                  strokeWidth={0.4}
                  style={{
                    default: { outline: "none" },
                    hover: { fill: "#d6d3d1", outline: "none" },
                    pressed: { outline: "none" },
                  }}
                />
              ))
            }
          </Geographies>
          {ready &&
            dots.map((d, i) => {
              if (typeof d.lon !== "number" || typeof d.lat !== "number") return null;
              return (
                <Marker key={i} coordinates={[d.lon, d.lat]}>
                  <circle r={6} fill="#c2410c" fillOpacity={0.15}>
                    <animate
                      attributeName="r"
                      from="4"
                      to="14"
                      dur="1.6s"
                      begin="0s"
                      repeatCount="indefinite"
                    />
                    <animate
                      attributeName="fill-opacity"
                      from="0.4"
                      to="0"
                      dur="1.6s"
                      begin="0s"
                      repeatCount="indefinite"
                    />
                  </circle>
                  <circle r={3} fill="#c2410c" />
                </Marker>
              );
            })}
        </ComposableMap>
      </div>
      {dots.length === 0 && (
        <p className="font-sans text-sm text-[var(--text-dim)] mt-3">
          No active visitors right now. Dots will pulse as sessions come in.
        </p>
      )}
    </div>
  );
}
